module.exports = __webpack_public_path__ + "img/logo.de93db64.svg";